import { stubFalse } from 'lodash';
import React, { useContext } from 'react';
import {
  DetailContext,
  EvidenceContext,
  FormPanel,
  Params,
  RemoteTableField,
  TableFieldToolbarProps,
} from '@eas/common-web';
import { EMPLOYMENT_SOURCE } from '@modules/audit-company/audit-company-hooked-sources';
import { RemoteTableToolbar } from '@components/toolbar/remote-table-toolbar';
import { Subject } from '@models';
import { EvidenceApiUrl } from '@enums';
import {
  addEmploymentApiCall,
  deleteEmploymentApiCall,
  editEmploymentApiCall,
} from './employment-api';
import { useColumns } from './employment-columns';
import { EmploymentDialog } from './employment-dialog';
import { useValidationSchema } from './employment-schema';

/**
 *
 * @param promptKeySuffix - Use it in cases where it's necessary to have multiple EmploymentFields in one form, with each having its specific behavior.
 */
export function EmploymentField({
  label = 'Všetci zamestnanci',
  disabled = false,
  display,
  type = EMPLOYMENT_SOURCE,
  autocompleteParams,
  promptKeySuffix = '',
  getLicenceNumber,
}: {
  promptKeySuffix?: string;
  getLicenceNumber?: (subject?: Subject) => string;
  label?: string;
  disabled?: boolean;
  display: 'IN_AUDIT_COMPANY' | 'IN_AUDITOR' | 'IN_SUBJECT';
  type?:
    | 'EMPLOYMENT_SOURCE'
    | 'AUDITOR_EMPLOYMENT_SOURCE'
    | 'SUBJECT_EMPLOYMENT_SOURCE';
  autocompleteParams?: Params;
}) {
  const detailCtx = useContext(DetailContext);
  const { hookedSources } = useContext(EvidenceContext);
  const source = hookedSources[type].source;

  const validationSchema = useValidationSchema();
  const columns = useColumns(display, getLicenceNumber);

  const Toolbar = (props: TableFieldToolbarProps) => (
    <RemoteTableToolbar
      {...props}
      source={source}
      dialogTitle="Zamestnanie"
      validationSchema={validationSchema}
      Dialog={() => EmploymentDialog({ autocompleteParams })}
      addButtonProps={{
        promptKey: `ADD_EMPLOYMENT_${promptKeySuffix}`,
        apiCall: addEmploymentApiCall,
      }}
      editButtonProps={{
        promptKey: `EDIT_EMPLOYMENT_${promptKeySuffix}`,
        apiCall: editEmploymentApiCall,
      }}
      deleteButtonProps={{
        promptKey: `DELETE_EMPLOYMENT_${promptKeySuffix}`,
        apiCall: deleteEmploymentApiCall,
      }}
      url={`${EvidenceApiUrl.AUDIT_COMPANY}/${detailCtx?.source?.data?.id}/employments`}
    />
  );

  return (
    <FormPanel label={label} expandable={true} defaultExpanded={true}>
      <RemoteTableField
        source={source}
        columns={columns}
        showDetailBtnCond={stubFalse}
        ToolbarComponent={Toolbar}
        showToolbar={!disabled}
        disabled={disabled}
      />
    </FormPanel>
  );
}
